import { cva } from 'class-variance-authority'

/** Shared button styles (docs/05-brand-tokens.md §8). Used by Button and LinkButton. */
export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 rounded-md font-semibold whitespace-nowrap transition-colors duration-150 ease-out focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        // hover = color shift + subtle lift (shadow), active = darker (pressed) — never scale.
        primary:
          'bg-brand text-white shadow-[var(--shadow-sm)] hover:bg-brand-hover hover:shadow-[var(--shadow-md)] active:bg-[color:var(--brand-primary-pressed)]',
        secondary:
          'border border-brand text-brand bg-transparent hover-tint-brand hover:border-brand-hover',
        ghost: 'text-text-primary hover:bg-hover',
        danger:
          'bg-[color:var(--color-danger)] text-white shadow-[var(--shadow-sm)] hover:shadow-[var(--shadow-md)] hover:brightness-95',
      },
      size: {
        sm: 'h-8 px-3 text-[13px]',
        md: 'h-10 px-4 text-[15px]',
        lg: 'h-12 px-5 text-[15px]',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: { variant: 'primary', size: 'md' },
  },
)
